import script from "./AssignTraining.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignTraining.vue?vue&type=script&setup=true&lang=js"

import "./AssignTraining.vue?vue&type=style&index=0&id=7280eb36&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7280eb36"]])

export default __exports__